import './verticalFraction.css';

export const VerticalFraction = ({ numerator, denominator }) => {
    return <div className="fraction">
        <span className="numerator">{numerator}</span>
        <span className="bar">/</span>
        <span className="denominator">{denominator}</span>
    </div>;
};
